import { useLang } from '@/i18n';
import EcoSpace from 'eco-design/base/eco-space';
import EcoSectionCarousel, { EcoSectionCarouselItemProps } from 'eco-design/sections/eco-section-carousel';
import styles from './index.module.scss';
import { Swiper } from 'swiper/types';
import { useEffect, useState } from 'react';

const JI: React.FC = () => {
    const { t } = useLang('delta3series');
    const [swiperDom, setSwiperDom] = useState<Swiper>();
    const itemsA: EcoSectionCarouselItemProps[] = [
        {
            icon: '',
            pc: 'https://websiteoss.ecoflow.com/upload/image/1741601876333/1.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1741601876333/1.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1741601866854/%E8%BD%BB1.jpg',
            title: t('I_item1_title'),
            desc: t('I_item1_desc'),
        },
        {
            icon: '',
            pc: 'https://websiteoss.ecoflow.com/upload/image/1741058706642/2.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1741058706642/2.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1741058790824/%E8%BD%BB2.jpg',
            title: t('I_item2_title'),
            desc: t('I_item2_desc'),
        },
        {
            icon: '',
            pc: 'https://websiteoss.ecoflow.com/upload/image/1741058706826/3.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1741058706826/3.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1741058791007/%E8%BD%BB3.jpg',
            title: t('I_item3_title'),
            desc: t('I_item3_desc'),
        },
    ];
    // 是否进入视图
    const enterViewChange = () => {
        const elem = document.querySelector('#d3-I');
        if (elem) {
            const ob1 = new IntersectionObserver((elems) => {
                const elem = elems[0];
                if (elem.isIntersecting) {
                    swiperDom && swiperDom?.slideTo(0, 100, false);
                }
            });
            ob1.observe(elem);
        }
    };
    useEffect(() => {
        enterViewChange();
    }, [swiperDom]);
    return (
        <div className={styles.comp} id="d3-I">
            <EcoSpace />
            <EcoSectionCarousel
                autoplay={{
                    delay: 3000,
                    stopOnLastSlide: false,
                    disableOnInteraction: false,
                }}
                swiperAutoPlay={true}
                label={t('I_label')}
                title={t('I_title')}
                desc={t('I_desc')}
                items={itemsA}
                getSwiperDom={(data: any) => {
                    setSwiperDom(data);
                }}
            />
        </div>
    );
};

export default JI;
